import React, {useState, useEffect} from 'react';
import Layout from './layout';
import {useParams} from 'react-router';
import api from '../../services/api';
import Modal from '../../components/Modal'

function ScrumBoard() {

  
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [addingState, setAddingState] = useState(null);
  const {id} = useParams();
  const [data, setData] = useState([
    {},
  ]);
  const [board, setBoard] = useState();
  const [members, setMembers] = useState();
  const [alertModal, setAlertModal] = useState(null);

  const onDataChange = (newData) => {
    api().put(`/board/${id}`, {data: newData})
    .then(result => {
      setData(newData);
    })
    .catch(err => {
      if (err?.response?.data?.msg) {
        setAlertModal(err.response.data.msg);
      }
    })
  }


  const onCardAdd = (rowIndex, colIndex) => {
    setAddingState({rowIndex, colIndex})
  }

  const onCardAddSubmit = (result) => {
    var tempData = JSON.parse(JSON.stringify(data));
    if (!tempData[addingState.rowIndex].cols[addingState.colIndex]) {
      tempData[addingState.rowIndex].cols[addingState.colIndex] = {cards: []}
    }
    tempData[addingState.rowIndex].cols[addingState.colIndex].cards.push(result);

    setAddingState(null);
    setData(tempData);
    onDataChange(tempData);
  }

  const closeModal = () => {
    setAddingState(null);
  }


  const onInvite = () => {
    
  }

  const getBoardData = () => {
    api().get(`/board/${id}`)
    .then(response => {
      if (response.data.result) {
        var dt = response.data.result;
        setBoard({title: dt.title, creatorId: dt.creatorId, description: dt.description});
        setData(dt.data);
        setMembers(dt.members);
      }
    })
    .catch(err => {
      if (err?.response?.data?.msg) {
        setAlertModal(err.response.data.msg);
      }
    })
  }

  useEffect(() => {
    getBoardData();
  }, [])

  return (
    <>
      <Layout 
      onInvite={onInvite}
      addingState={addingState} 
      closeModal={closeModal} 
      data={data} 
      board={board}
      members={members}
      onCardAdd={onCardAdd} 
      onCardAddSubmit={onCardAddSubmit} 
      onDataChange={onDataChange}
      forceUpdate={forceUpdate}
      />
      <Modal visible={alertModal !== null} title={"Alert"} onCancel={() => setAlertModal(null)} onSubmit={() => setAlertModal(null)} cancelText={false} >
        {alertModal}
      </Modal>
    </>
  )
}

export default ScrumBoard;